import React, { useEffect } from "react";
import propTypes from "prop-types";
import Analytics from "../../../../helpers/analytics"
import { createBoxes } from "../../../../helpers";
import { Link } from "react-router-dom";
import { ThanksContainer } from "./styles";

export default function Thanks(props) {
  useEffect(() => {
    props.getTrendingVideos();
    window.scrollTo({ top: 0 });
  }, []);

  let { addToCart, auth, removeFromCart, search, user } = props;
  let addFavorite = props.toggleModal;
  let removeFavorite = props.removeVideoFromList;
  let { results } = search;

  return (
    <ThanksContainer>
      <section id="thank-you" className="inquiry-thankyou">
        <div className="inner-sp">
          <div className="row">
            <div className="col-12 align-center">
              <div className="thanks">
                <h1>Thank you for your inquiry</h1>
                <p>
                  Someone from our licensing department will be contacting you
                  shortly!
                </p>
              </div>
            </div>
          </div>
          <div className="clearer" />
          <br />
          <br />
          <div className="row">
            <div className="col-12 align-center">
              <Link
                onClick={() =>
                  Analytics.track("ThankYouPage", {
                    category: "LP-Inquiry",
                    label: "VideoLibrary",
                  })
                }
                className="cart-thanks"
                to="/licensing/search"
              >
                Video Library
              </Link>
            </div>
          </div>
          <div className="clearer" />
          <br />
          <br />
          <div className="row align-center">
            <div className="col-12 additional-videos">
              <h2>Additional Videos You Might like</h2>

              <div className="search-result">
                <div id="video-box-template" className="searchItem">
                  {results
                    ? createBoxes({
                        videos: results.slice(0, 3).map((it) => it.fields),
                        user: user,
                        auth: auth,
                        methods: {
                          addFavorite: addFavorite,
                          removeFavorite: removeFavorite,
                          addToCart: addToCart,
                          removeFromCart: removeFromCart,
                        },
                      })
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ThanksContainer>
  );
}

Thanks.propTypes = {
  addFavorite: propTypes.func,
  addToCart: propTypes.func,
  auth: propTypes.object,
  removeFavorite: propTypes.func,
  removeFromCart: propTypes.func,
  user: propTypes.object,
  videos: propTypes.object,
};
